<div class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/reports']">Reports</a> > Outstanding Receivables</h3>
    </div>
    <div class="form-actions" *ngIf="speaker.listData.length > 0">
      <a target="_blank" [href]="pdf_url">
        <button type="button" mat-stroked-button><mat-icon>picture_as_pdf</mat-icon> View Pdf</button>
      </a>
    </div>
  </div>
  <div class="form-card">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select Till Date</mat-label>
          <input [(ngModel)]="tillDate" matInput name="till_date" [matDatepicker]="till_date" required>
          <mat-datepicker-toggle matSuffix [for]="till_date">
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #till_date></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select Doctor</mat-label>
          <mat-select #doctorRef (openedChange)="doctor.attachScroll(doctorRef)" [(value)]="doctor.selectedId" required>
            <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="doctor.onSearch($event)" matInput name="doctor_list">
            <mat-option [value]="0">All</mat-option>
            <mat-option *ngFor="let opt of doctor.items" [value]="opt.id">{{opt.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 mb-3">
        <button type="button" mat-flat-button color="primary" (click)="generateReport()">Generate Report</button>
      </div>
    </div>
  </div>
</div>

<div class="report-loading" *ngIf="speaker.isLoading && speaker.listData.length === 0">
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  <span>Loading report...</span>
</div>

<app-report-list-container *ngIf="speaker.listData.length > 0"></app-report-list-container>